import {Component, OnInit, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Formatters} from 'angular-slickgrid';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-ticket-property',
  templateUrl: './ticket-property.component.html',
  styleUrls: ['./ticket-property.component.css']
})
export class TicketPropertyComponent implements OnInit, OnDestroy {

  displayed = true;
  propertyName: string;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;
  displayData: any;

  isError = false;
  errorMessage: string;
  clientId: number;
  private baseFlag: any;
  nextOffset: number;
  previousOffset: number;
  collectionSize: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private adminAuth: Subscription;

  private notifier: NotifierService;
  offset: number;
  dataLoaded:boolean;

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            if (confirm('Are you sure?')) {
              const data = {
                name: item.propertyName, desc: item.MODDESCRIPTION, createdBy: this.messageService.getUserId(), id: item.id
              };
              // this._rest.editModuleMst(data).subscribe((res) => {
              //   this.respObject = res;
              //   if (this.respObject.success) {
              //     console.log('data--Done');
              //     // this.notifier.notify('success', 'Module added successfully');
              //   } else {
              //     console.log('data--Not---Done');
              //     // this.notifier.notify('error', this.respObject.errorMessage);
              //   }
              // }, (err) => {
              //   // this.notifier.notify('error', this.respObject.errorMessage);
              // });
            }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
            }
          }
          break;
      }
    });

    this.messageService.getUserAuth().subscribe(details => {
      console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Ticket Property',
      openModalButton: 'Add Ticket Property',
      breadcrumb: 'TicketProperty',
      folderName: 'All Ticket Property',
      tabName: 'TicketProperty'
    };

    const columnDefinitions = [
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'name', name: 'Property', field: 'name', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
  }

  onPageLoad() {
    this.getTableData();
  }

  openModal(content) {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.propertyName = '';
      // this.notifier.notify('success', 'Module added successfully');
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }

  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  save() {
    const data = {
      name: this.propertyName, createdBy: this.messageService.getUserId()
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertTicketProperty(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
            this.totalData = this.totalData + 1;
            this.messageService.setTotalData(this.totalData);
          const id = this.respObject.details;
          this.messageService.setRow({id: id, name: this.propertyName});
            if (this.totalData <= this.pageSize * this.page_no) {
                this.offset = id;
                this.nextOffset = 0;
            } else {
                this.nextOffset = this.offset;
            }
          this.propertyName = '';

        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

  }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getTicketProperty(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }

}
